var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3091_12604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5C16.8284 8.5 17.5 7.82843 17.5 7C17.5 6.17157 16.8284 5.5 16 5.5C15.1716 5.5 14.5 6.17157 14.5 7C14.5 7.82843 15.1716 8.5 16 8.5Z",
    fill: "#304FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99999 12.5H30C30.897 12.5 31.684 11.903 31.926 11.039C32.168 10.175 31.805 9.256 31.0385 8.7905L17.0385 0.2905C16.719 0.0965 16.3595 0 16 0C15.6405 0 15.281 0.0965 14.962 0.2905L0.961994 8.7905C0.195494 9.256 -0.168006 10.1755 0.0744937 11.039C0.315994 11.903 1.10299 12.5 1.99999 12.5ZM16 4.5C17.381 4.5 18.5 5.619 18.5 7C18.5 8.381 17.381 9.5 16 9.5C14.619 9.5 13.5 8.381 13.5 7C13.5 5.619 14.619 4.5 16 4.5Z",
    fill: "#304FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5H17V26H21V13.5Z",
    fill: "#304FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 13.5H23V26H27V13.5Z",
    fill: "#304FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5H11V26H15V13.5Z",
    fill: "#304FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5H5V26H9V13.5Z",
    fill: "#304FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 29H30C30 27.8955 29.1045 27 28 27H4C2.8955 27 2 27.8955 2 29Z",
    fill: "#304FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7225 30H0.2775C0.1055 30.2955 0 30.634 0 31V32H32V31C32 30.634 31.8945 30.2955 31.7225 30Z",
    fill: "#304FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3091_12604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.50fdf8fad9df2e5bb7148d95a1ffdfff.svg";
export { ForwardRef as ReactComponent };